export default "__VITE_ASSET__BTKW0U7H__"